import jwtService from '@/services/common/jwt.service';
import $backgroundService from '@/services/common/background.service';

export class DepartmentService {
  public async loadDepartments(companyName: string) {
    const user = await jwtService.getUser();
    const response = await $backgroundService.query(
      `admins/${user.id}/system/departments`,
      {
        companyName: companyName
      }
    );
    return response.data.data as string[];
  }
}

const departmentService = new DepartmentService();
export default departmentService;
